// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { DataSanitizer, UrlHelper, DateTimeUtils } from '@microsoft/applicationinsights-common';
var XHRMonitoringState = /** @class */ (function () {
    function XHRMonitoringState() {
        this.openDone = false;
        this.setRequestHeaderDone = false;
        this.sendDone = false;
        this.abortDone = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        this.onreadystatechangeCallbackAttached = false;
    }
    return XHRMonitoringState;
}());
export { XHRMonitoringState };
var ajaxRecord = /** @class */ (function () {
    function ajaxRecord(traceID, spanID, logger) {
        this.completed = false;
        this.requestHeadersSize = null;
        this.requestHeaders = null;
        this.ttfb = null;
        this.responseReceivingDuration = null;
        this.callbackDuration = null;
        this.ajaxTotalDuration = null;
        this.aborted = null;
        this.pageUrl = null;
        this.requestUrl = null;
        this.requestSize = 0;
        this.method = null;
        /// <summary>Returns the HTTP status code.</summary>
        this.status = null;
        // <summary>The timestamp when open method was invoked</summary>
        this.requestSentTime = null;
        // <summary>The timestamps when first byte was received</summary>
        this.responseStartedTime = null;
        // <summary>The timestamp when last byte was received</summary>
        this.responseFinishedTime = null;
        // <summary>The timestamp when onreadystatechange callback in readyState 4 finished</summary>
        this.callbackFinishedTime = null;
        // <summary>The timestamp at which ajax was ended</summary>
        this.endTime = null;
        // <summary>The original xhr onreadystatechange event</summary>
        this.originalOnreadystatechage = null;
        this.xhrMonitoringState = new XHRMonitoringState();
        // <summary>Determines whether or not JavaScript exception occured in xhr.onreadystatechange code. 1 if occured, otherwise 0.</summary>
        this.clientFailure = 0;
        this.CalculateMetrics = function () {
            var self = this;
            // round to 3 decimal points
            self.ajaxTotalDuration = Math.round(DateTimeUtils.GetDuration(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
        };
        this.traceID = traceID;
        this.spanID = spanID;
        this._logger = logger;
    }
    ajaxRecord.prototype.getAbsoluteUrl = function () {
        return this.requestUrl ? UrlHelper.getAbsoluteUrl(this.requestUrl) : null;
    };
    ajaxRecord.prototype.getPathName = function () {
        return this.requestUrl ? DataSanitizer.sanitizeUrl(this._logger, UrlHelper.getCompleteUrl(this.method, this.requestUrl)) : null;
    };
    return ajaxRecord;
}());
export { ajaxRecord };
;
//# sourceMappingURL=ajaxRecord.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-dependencies-js/dist-esm/ajaxRecord.js
// module id = 232
// module chunks = 42